var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("DELETE_PREDICTIVE_ROUTING_CONFIG_CONFIRMATION_TITLE"),
        entity: _vm.predictiveRoutingConfig,
        "show-confirm-button": true,
        "show-cancel-button": true,
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-disabled": _vm.disableModalConfirm,
        "confirm-button-loading": _vm.deletingPredictiveRoutingConfig
      },
      on: { close: _vm.closeModal, confirm: _vm.deletePredictiveRoutingConfig }
    },
    [
      _c(
        "div",
        [
          _c("i18n", {
            attrs: {
              path: "DELETE_PREDICTIVE_ROUTING_CONFIG_MODAL_TEXT",
              tag: "p"
            },
            scopedSlots: _vm._u([
              {
                key: "predictiveRoutingConfigToDeleteName",
                fn: function() {
                  return [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.predictiveRoutingConfigToDeleteName))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-horizontal m-l-10 m-r-10" }, [
            _c("div", { staticClass: "checkbox" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.forceDelete,
                      expression: "forceDelete"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.forceDelete)
                      ? _vm._i(_vm.forceDelete, null) > -1
                      : _vm.forceDelete
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.forceDelete,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.forceDelete = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.forceDelete = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.forceDelete = $$c
                        }
                      },
                      _vm.attestDelete
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "DELETE_PREDICTIVE_ROUTING_CONFIG_ATTEST_NONE",
                      expression:
                        "'DELETE_PREDICTIVE_ROUTING_CONFIG_ATTEST_NONE'"
                    }
                  ]
                })
              ])
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }